import { render, staticRenderFns } from "./AuditRecordDetail.vue?vue&type=template&id=adc280fc&scoped=true"
import script from "./AuditRecordDetail.vue?vue&type=script&lang=js"
export * from "./AuditRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./AuditRecordDetail.vue?vue&type=style&index=0&id=adc280fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc280fc",
  null
  
)

export default component.exports